import { render, staticRenderFns } from "./FormulaireResiliation.vue?vue&type=template&id=c1f24e38&scoped=true"
import script from "./FormulaireResiliation.vue?vue&type=script&lang=js"
export * from "./FormulaireResiliation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1f24e38",
  null
  
)

export default component.exports